import { INSTALLATION_PHASES } from './installationPhases';
import type { EstimateLineItem } from '@/hooks/useEstimateLineItems';

export function groupLineItemsByPhase(
  lineItems: EstimateLineItem[]
): Record<string, EstimateLineItem[]> {
  const grouped: Record<string, EstimateLineItem[]> = {};
  
  INSTALLATION_PHASES.forEach(phase => {
    const phaseItems = lineItems.filter(item => 
      item.products?.install_phase === phase.key
    );
    if (phaseItems.length > 0) {
      grouped[phase.key] = phaseItems;
    }
  });
  
  return grouped;
}

export function getPhaseInfo(phaseKey: string) {
  return INSTALLATION_PHASES.find(p => p.key === phaseKey);
}
